/* eslint-disable react-hooks/exhaustive-deps */
import React, {  useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  InputAdornment,
  TextField,
  LinearProgress,
  Typography,
  Link,
  IconButton,
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import "./style.css";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";
import { useNavigate } from "react-router-dom";

const FleetDailyReport = () => {
  const [searchValInput, setSearchValInput] = useState("");
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState<any>();
  const [notificationListData, setNotificationListData] = useState<any[]>([]);
  
const navigate = useNavigate();
  const rowsPerPage = 10;
  const pageRange = 5;

  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#A4A2A2",
    font: "Rubik",
  };
  // Dummy data for tables
  const handleBackToDashboard = () => {
    navigate("/overview"); // Navigate back to Dashboard with EV Details tab active
  };
  const pageCount = Math.ceil(totalCount / rowsPerPage);
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };
  const handleCreateNotification = () => {
    //   setUserId(uid);
    navigate("/createNotification");
  };
  useEffect(() => {
      ZyppLiteApi.api?.notificationList(searchValInput, page, rowsPerPage)
        .then((response) => {
          if (response.data.notificationsList.length > 0) {
            setNotificationListData(response.data.notificationsList);
            setTotalCount(response.data.total);
  
          } else {
            setNotificationListData([]);
            setTotalCount(1);
          }
        })
        .catch((error) => {
          console.error("API call error: ", error);
        });
    }, [page, rowsPerPage, searchValInput]);

  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };
  const editnotification = (item: any) => {
   
    navigate("/editNotification", { state: item });

}
  const handleClearSearch = () => {
    setSearchValInput("");
  };
  
  const formatDate = (isoString:any) => {
    const date = new Date(isoString);
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(date);
  };

  return (
    <Grid container >
    <div className="w-full flex bg-white min-h-80 box-shadow p-3 rounded-xl m-10">
      <div className="w-full">
        <Grid container spacing={5} className="w-full flex justify-between ">
          <Grid item md={3}>
              <div className="flex ml-4">
                <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                                  <IconButton  onClick={handleBackToDashboard}>
                  
                  <ArrowBackIcon /> 
                  </IconButton>
                 Notification List
                </h2>
              </div>
            </Grid>
          <Grid item md={9}>
            <div className="flex mr-4">
              <div className="flex w-full justify-end">
                <div className="mr-3">
                  <TextField
                    placeholder="Search  Vehicle Number"
                    id="outlined-basic"
                    variant="outlined"
                    onChange={(search: any) =>
                      setSearchValInput(search.target.value)
                    }
                    value={searchValInput}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          onClick={handleClearSearch}
                        >
                          <ClearIcon style={{ cursor: "pointer" }} />
                        </InputAdornment>
                      ),
                      style: { height: "40px", borderRadius: "25px" },
                    }}
                    // onKeyDown={handleKeyPress}
                  />
                </div>

                <div>
                <Link
              sx={{ cursor: "pointer" }}
              onClick={() => {
                handleCreateNotification();
              }}
            >
                <Button
                  style={{
                    backgroundColor: "#000",
                    padding: "5px 18px",
                    color: "#fff",
                    borderRadius: "40px",
                    width: "100%",
                    textTransform: "none",
                    fontSize:'16px'
                  }}
                >
                 <AddIcon/> Add Notification
                </Button>
                </Link>
                </div>
               

              </div>
            </div>
          </Grid>
        </Grid>
        <hr className="my-4" />

        <TableContainer  style={{ width: "100%", overflowX: "auto" }}>
          {!notificationListData ? ( // Check if API response is still undefined (loading)
            <LinearProgress />
          ) : typeof notificationListData === "string" ? ( // If API returns "No Data Found" as a string
            <Typography style={{ textAlign: "center", padding: "10px" }}>
              No data available
            </Typography>
          ) : notificationListData.length === 0 ? ( // If the array is empty
            <Typography style={{ textAlign: "center", padding: "10px" }}>
              No data available
            </Typography>
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 120 }}
                  >
                    ID
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 150 }}
                  >
                   Header Line
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 110 }}
                  >
                    Description
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 110 }}
                  >
                   Image
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 100 }}
                  >
                   URL
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 100 }}
                  >
                    Start Date/Time
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 100 }}
                  >
                    End Date/Time
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 100 }}
                  >
                    Last Modify
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 100 }}
                  >
                   Action
                  </TableCell>
                 
                </TableRow>
              </TableHead>
              <TableBody>
                {notificationListData.map(
                  (item: any, index: any) => (
                    <TableRow key={index}>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.id}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.headerLine}
                      </TableCell>
                     
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.description}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.image}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.url}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {formatDate(item.startTime)}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {formatDate(item.endTime)}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {formatDate(item.modifiedAt)}
                      </TableCell>
                      <TableCell  style={{ ...tableBodyCellStyle, textAlign: "center" }}>
                                           <img
                                     src={"/assets/edit-icon.svg"}
                                     alt="edit"
                                     onClick={() => editnotification(item)}
                                     style={{ cursor: "pointer", display: "block", margin: "auto" }}
                                     />
                                           </TableCell>
                      
                      
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          )}
        </TableContainer>

        <div className="pl-2 pt-4 pb-2 pr-16">
          <div
            className="pagination"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <button
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 0}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginRight: "6px",
                }}
              >
                {"<"}
              </button>
              {renderPageNumbers()}
              <button
                onClick={() => handlePageChange(page + 1)}
                disabled={page >= pageCount - 1}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginLeft: "6px",
                }}
              >
                {">"}
              </button>
            </div>
          </div>
        </div>
      </div>
       
    </div>
    </Grid>
  );
};

export default FleetDailyReport;
